import {ProductListColumnFlags} from "./types";

const getProductListFlags = (products?: ProductListItem[]): ProductListColumnFlags => ({
  hasGrossWeightManual: Boolean(products?.some((product) => product.gross_weight_manual > 0)),
  hasNetWeightManual: Boolean(products?.some((product) => product.net_weight_manual > 0)),
  hasPalleteCnt: Boolean(products?.some((product) => product.pallete_cnt > 0)),
  hasPalleteType: Boolean(products?.some((product) => product.pallete_type !== null)),
  hasVolumeCartoon: Boolean(products?.some((product) => product.volume_cartoon > 0)),
  hasVolumeManual: Boolean(products?.some((product) => product.volume_manual > 0)),
});

export default getProductListFlags
